import { render, staticRenderFns } from "./Ramblings.vue?vue&type=template&id=5fc8405c&scoped=true&"
import script from "./Ramblings.vue?vue&type=script&lang=ts&"
export * from "./Ramblings.vue?vue&type=script&lang=ts&"
import style0 from "./Ramblings.vue?vue&type=style&index=0&id=5fc8405c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8405c",
  null
  
)

export default component.exports